const TestimonialsSection = () => {
  const testimonials = [
    {
      rating: 5,
      comment: '産後の体型が気になっていましたが、Fit Carvingで3ヶ月通ったら、ウエストが-8cm！無理な食事制限もなく、楽しく通えました。藤井さんの丁寧なカウンセリングも心強かったです。',
      name: '40代・産後太り',
      menu: 'Fit Carving ボディメイクコース',
      avatar: 'https://public.readdy.ai/ai/img_res/a65e58e01fcf12c46cc78181d60fdc72.jpg',
    },
    {
      rating: 5,
      comment: '長年悩んでいた毛穴とくすみが、Revcellaで本当に改善されました。1回目から肌のトーンが明るくなったのを実感。今では友人にも「肌きれいになったね」と言われます。',
      name: '50代・肌のくすみ',
      menu: 'Revcella フェイシャルコース',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2050s%20smiling%20portrait%2C%20professional%20headshot%2C%20simple%20white%20background%2C%20natural%20makeup%2C%20radiant%20skin%2C%20elegant%20mature%20beauty&width=200&height=200&seq=avatar-002&orientation=squarish',
    },
    {
      rating: 5,
      comment: '抜け毛が増えて悩んでいましたが、MOUMITUのヘッドスパを始めてから髪にハリとコシが出てきました。頭皮マッサージも気持ちよくて、リラックスできる時間です。',
      name: '30代・産後の抜け毛',
      menu: 'MOUMITU 頭皮ケアコース',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2030s%20smiling%20portrait%2C%20professional%20headshot%2C%20simple%20white%20background%2C%20natural%20makeup%2C%20youthful%20appearance%2C%20healthy%20hair&width=200&height=200&seq=avatar-003&orientation=squarish',
    },
    {
      rating: 5,
      comment: '駅から近くて通いやすいのが魅力。完全個室なので他の人を気にせずリラックスできます。施術後は体が軽くなって、毎回通うのが楽しみです。',
      name: '60代・たるみ',
      menu: 'LED光トリートメント',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2060s%20smiling%20portrait%2C%20professional%20headshot%2C%20simple%20white%20background%2C%20natural%20makeup%2C%20graceful%20aging%2C%20warm%20expression&width=200&height=200&seq=avatar-004&orientation=squarish',
    },
    {
      rating: 5,
      comment: 'エステは初めてでしたが、丁寧な説明と無理な勧誘がないので安心して通えています。自分に合ったプランを提案してくれるのが嬉しいです。',
      name: '35代・初めてのエステ',
      menu: 'トータルケアプラン',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20her%2035%20smiling%20portrait%2C%20professional%20headshot%2C%20simple%20white%20background%2C%20natural%20makeup%2C%20fresh%20appearance%2C%20confident%20smile&width=200&height=200&seq=avatar-005&orientation=squarish',
    },
    {
      rating: 5,
      comment: '仕事帰りに寄れる立地が便利。最新のマシンで効率的にケアできるので、忙しい私にぴったりです。結果が出るのが早くてモチベーションも上がります。',
      name: '45代・ビジネスパーソン',
      menu: 'Fit Carving + Revcella',
      avatar: 'https://readdy.ai/api/search-image?query=Japanese%20businesswoman%20in%20her%2045%20smiling%20portrait%2C%20professional%20headshot%2C%20simple%20white%20background%2C%20natural%20makeup%2C%20professional%20appearance%2C%20sophisticated%20style&width=200&height=200&seq=avatar-006&orientation=squarish',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-beige px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold text-center text-dark-gray mb-12 md:mb-16">
          お客様の声
        </h2>
        <div className="space-y-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold text-lg"></i>
                ))}
              </div>
              <p className="text-dark-gray leading-relaxed mb-6 text-sm md:text-base font-serif">
                「{testimonial.comment}」
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden bg-light-gold flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-dark-gray text-sm md:text-base">
                    {testimonial.name}
                  </p>
                  <p className="text-xs md:text-sm text-medium-gray truncate">
                    {testimonial.menu}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
